module.exports = __webpack_public_path__ + "img/D@2x.edcb214.jpg";